const attachment = {
  attachment: 'Attachment',
  'attachment.attachment': 'Attachment',
  'attachment.accepttext': 'Supports xlsx/jpg/png/pdf files, size limit: 10MB',
  'attachment.errsize': 'File size must be less than 10MB',
  'attachment.errtype': 'Invalid file format',
  'attachment.uploadfile': 'Upload File',
};

export default attachment;
